var path = 'areas/projects/views/action_editor.html';
var html = "<div> <div class=action-details></div> <div class=action-features></div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/views/action_editor.html
// module id = 6375034517616292
// module chunks = 1